import styled from "styled-components";

/** One labelled field: label above its input, app chrome styling. */
export const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.35rem;
    padding-top: 1rem;
    text-align: left;

    label {
        font-size: 0.9rem;
        font-weight: 500;
        color: #333333; /* 12.6:1 on white (AAA) */
    }
`;
